<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    작업구분-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 작업구분
        </h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-3 flex items-center"
            v-for="checkbox in form.inspectionList"
            v-bind:key="checkbox.id"
      >
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox
            :readonly="board.readonly"
            v-model="checkbox.check"
            @change="checkForm">
          </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    작업허가서 정보-->
    <vs-row class="mt-8">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 작업허가서 정보</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">협력업체명</div>
        <span v-if="isPrint" class=" print-input flex-1"> {{ form.companyName }} </span>
        <CompanySelector
          v-else
          :readonly="board.readonly"
          class="w-full flex-1"
          v-model="form.inputC_1"
          placeholder="선택"
          @select="targetCompany"
        ></CompanySelector>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">공종명</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputC_2 }}</p>
        <vs-input
          v-else
          v-model="form.inputC_2"
          class="w-full flex-1"
          :readonly="board.readonly"
        ></vs-input>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업일자</div>
        <p v-if="isPrint" class="print-input flex-1">
          {{ form.inputC_3 }}
        </p>
        <div v-else class="flex-1 flex items-center">
          <date-selector
            class="w-full"
            v-model="form.inputC_3"
            :readonly="board.readonly"
          />
        </div>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업시간</div>
        <p v-if="isPrint" class=" print-input flex-1">
          {{ form.inputC_4 }} ~ {{ form.inputC_5 }}
        </p>
        <div
          v-else
          class="w-full flex-1"
          style="display: flex; align-items: center"
        >
          <time-selector
            v-model="form.inputC_4"
            :readonly="board.readonly"
          />
          &nbsp;~&nbsp;
          <time-selector
            v-model="form.inputC_5"
            :readonly="board.readonly"
          />
        </div>
      </div>
    </div>
    <div class="print-container col-span-12 flex items-start mt-4">
      <div class="label-text mr-4 mt-2">작업개요</div>
      <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputC_6 }}</p>
      <vs-textarea
        :readonly="board.readonly"
        v-else
        v-model="form.inputC_6"
        class="flex-1 w-full"
        rows="5"
      />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableInspectDivision from '@/components/TableInspectDivision'
import TableDuration from '../../../../components/TableDuration'
import TimeSelector from '@/components/selector/TimeSelector'

export default {
  components: {
    TimeSelector,
    TableDuration,
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }

        if (!this.form || !this.form.inspectionList || this.form.inspectionList.length === 0) {
          this.form.inspectionList = this.inspectionList
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    targetCompany (value) {
      this.form.companyName = value.com_name
    },
    checkForm () {
      this.form.typeTitleList = []
      for (const data of this.form.inspectionList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label)
        }
      }
    },
  },
  computed: {
    inspectionList () {
      return [
        {
          id: 1,
          label: '화기작업',
          check: false,
        },
        {
          id: 2,
          label: '고소작업',
          check: false,
        },
        {
          id: 3,
          label: '장비작업',
          check: false,
        },
        {
          id: 4,
          label: '활선작업',
          check: false,
        },
        {
          id: 5,
          label: '구조물 해체작업',
          check: false,
        },
        {
          id: 6,
          label: '밀폐공간작업',
          check: false,
        },
        {
          id: 7,
          label: '고위험작업',
          check: false,
        },
      ];
    }
  },
  data () {
    return {
      form: {
        stdInfo: {},

        inputB_1: '',

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",

        fileList: [],
        companyName:'',
        typeTitleList: [],
        inspectionList: [],
      },
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
